import { storyblokEditable } from "@storyblok/react";

const Card = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="font-display ">
      <div className="card">
        <p className="preamble">{blok.preamble}</p>
        <h3>{blok.title}</h3>
        <p className="desc">{blok.description}</p>
      </div>
    </div>
  );
};

export default Card;
